import { render, staticRenderFns } from "./custromInfo.vue?vue&type=template&id=41bf9d1a"
import script from "./custromInfo.vue?vue&type=script&lang=js"
export * from "./custromInfo.vue?vue&type=script&lang=js"
import style0 from "./custromInfo.vue?vue&type=style&index=0&id=41bf9d1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports